import { render, staticRenderFns } from "./Licenca.vue?vue&type=template&id=6fb6674a&scoped=true"
import script from "./Licenca.vue?vue&type=script&lang=js"
export * from "./Licenca.vue?vue&type=script&lang=js"
import style0 from "./Licenca.vue?vue&type=style&index=0&id=6fb6674a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb6674a",
  null
  
)

export default component.exports